/**
 * Opening Hours Validation for Search Form
 *
 * Features:
 * - Validates if stations in a city are open at the selected date/time
 * - Shows warning if all stations are closed
 * - Suggests alternative opening hours
 * - Debounced AJAX calls for performance
 *
 * @version 1.0.0
 * @date 2025-01-03
 */
(function($) {
    'use strict';

    var OpeningHoursValidation = window.OpeningHoursValidation = {
        // Configuration
        config: {
            debounceMs: 400,
            endpoint: '/api/validate-opening-hours',
            // Warning containers per tab
            warningContainers: {
                lkw: 'opening-hours-warning',
                nutzfahrzeuge: 'opening-hours-warning-nutz',
                modal: 'opening-hours-warning-modal'
            },
            // Selectors for all form variants (LKW, Transporter, Nutzfahrzeuge)
            selectors: {
                cityId: '#anmietort_city_id, #anmietort_station_id, #anmietort_station_id-transporter, #nutz-anmietort-station-id, #nutz-standort_station_id, #modal-anmietort-city-id',
                date: '#anmietdatum, #anmietdatum-transporter, #nutz-anmietdatum',
                time: '#anmietzeit, #anmietzeit-transporter, #nutz-anmietzeit'
            }
        },

        // State
        _currentCityId: null,
        _debounceTimer: null,
        _lastValidation: null,
        warningActive: false,

        /**
         * Initialize the module
         */
        init: function() {
            var self = this;

            // Create warning container if it doesn't exist
            this._ensureWarningContainer();

            // Bind events
            this._bindEvents();

        },

        /**
         * Detect which tab/context is currently active
         * @returns {string} 'lkw', 'nutzfahrzeuge', or 'modal'
         */
        _getActiveTab: function() {
            if ($('#search-edit-modal').hasClass('in') || $('#search-edit-modal').is(':visible')) {
                return 'modal';
            }
            if ($('#tab-nutzfahrzeuge').hasClass('active') || $('#nutzfahrzeugeSearchDesktop').is(':visible')) {
                return 'nutzfahrzeuge';
            }
            return 'lkw';
        },

        /**
         * Get the warning container ID for the active tab
         * @returns {string} Container ID
         */
        _getWarningContainerId: function() {
            var activeTab = this._getActiveTab();
            return this.config.warningContainers[activeTab] || this.config.warningContainers.lkw;
        },

        /**
         * Ensure warning containers exist in the DOM for each tab
         */
        _ensureWarningContainer: function() {
            var self = this;
            // LKW/Transporter container
            if ($('#' + this.config.warningContainers.lkw).length === 0) {
                var $lkwDateField = $('#anmietdatum').closest('.form-group, .row, .input-group');
                if ($lkwDateField.length) {
                    $lkwDateField.after('<div id="' + this.config.warningContainers.lkw + '" class="alert-form-hint" style="display: none; margin-top: 10px;"></div>');
                }
            }
            // NFZ container
            if ($('#' + this.config.warningContainers.nutzfahrzeuge).length === 0) {
                var $nutzDateField = $('#nutz-anmietdatum').closest('.form-group, .row, .input-group, .col-lg-3, .col-md-3');
                if ($nutzDateField.length) {
                    $nutzDateField.after('<div id="' + this.config.warningContainers.nutzfahrzeuge + '" class="alert-form-hint" style="display: none; margin-top: 10px;"></div>');
                }
            }
        },

        /**
         * Bind event listeners
         */
        _bindEvents: function() {
            var self = this;

            // Listen for city selection events from city-autocomplete.js
            $(document).on('citySelected stationSelected', function(e, data) {
                if (data && data.id) {
                    self._currentCityId = data.id;
                    // Update modal hidden field if it exists
                    $('#modal-anmietort-city-id').val(data.id);
                    // Trigger validation if date/time are set
                    self._scheduleValidation();
                }
            });

            // Listen for date/time changes
            $(document).on('change', this.config.selectors.date + ', ' + this.config.selectors.time, function() {
                self._scheduleValidation();
            });

            // Also listen for datepicker onSelect events
            $(document).on('dateSelected', function(e, date) {
                self._scheduleValidation();
            });

            // When search-edit modal opens, trigger validation with existing values
            $(document).on('shown.bs.modal', '#search-edit-modal', function() {
                var modalCityId = $('#modal-anmietort-city-id').val();
                if (modalCityId) {
                    self._currentCityId = parseInt(modalCityId);
                }
                // Reset last validation to force re-check
                self._lastValidation = null;
                self._scheduleValidation();
            });

            // When modal closes, hide modal warning
            $(document).on('hidden.bs.modal', '#search-edit-modal', function() {
                $('#opening-hours-warning-modal').hide();
            });
        },

        /**
         * Schedule validation with debounce
         */
        _scheduleValidation: function() {
            var self = this;

            if (this._debounceTimer) {
                clearTimeout(this._debounceTimer);
            }

            this._debounceTimer = setTimeout(function() {
                self._performValidation();
            }, this.config.debounceMs);
        },

        /**
         * Normalize date format - remove weekday prefix if present
         * "So, 11.01.2026" -> "11.01.2026"
         */
        _normalizeDate: function(dateStr) {
            if (!dateStr) return null;
            // Match pattern: "Wochentag, DD.MM.YYYY" (e.g., "So, 11.01.2026")
            var match = dateStr.match(/^[A-Za-z]{2},\s*(\d{2}\.\d{2}\.\d{4})$/);
            if (match) {
                return match[1];
            }
            return dateStr;
        },

        /**
         * Get current form values
         */
        _getFormValues: function() {
            var self = this;
            // Try multiple selectors to find the active form
            var cityId = this._currentCityId;
            var cityName = null;

            // If no city selected via event, try to get from hidden field
            if (!cityId) {
                $(this.config.selectors.cityId).each(function() {
                    var val = $(this).val();
                    if (val && parseInt(val) > 0) {
                        cityId = parseInt(val);
                        return false; // break
                    }
                });
            }

            // Fallback: use city name from #anmietort input (e.g. search-edit modal)
            if (!cityId) {
                var $anmietort = $('#anmietort');
                if ($anmietort.length && $anmietort.val()) {
                    cityName = $.trim($anmietort.val());
                }
            }

            // Get date - try visible/active field first, then any field with value
            var date = null;
            $(this.config.selectors.date).each(function() {
                var $field = $(this);
                if ($field.is(':visible') && $field.val()) {
                    date = self._normalizeDate($field.val());
                    return false;
                }
            });
            // Fallback: try any field with value (for custom styled inputs)
            if (!date) {
                $(this.config.selectors.date).each(function() {
                    var $field = $(this);
                    if ($field.val()) {
                        date = self._normalizeDate($field.val());
                        return false;
                    }
                });
            }

            // Get time - try visible/active field first, then any field with value
            var time = null;
            $(this.config.selectors.time).each(function() {
                var $field = $(this);
                if ($field.is(':visible') && $field.val()) {
                    time = $field.val();
                    return false;
                }
            });
            // Fallback: try any field with value (for hidden selects with custom dropdowns)
            if (!time) {
                $(this.config.selectors.time).each(function() {
                    var $field = $(this);
                    if ($field.val()) {
                        time = $field.val();
                        return false;
                    }
                });
            }

            return {
                cityId: cityId,
                cityName: cityName,
                date: date,
                time: time
            };
        },

        /**
         * Perform the validation via AJAX
         */
        _performValidation: function() {
            var self = this;
            var values = this._getFormValues();

            // Need city (ID or name) + date + time to validate
            if ((!values.cityId && !values.cityName) || !values.date || !values.time) {
                this._hideWarning();
                return;
            }

            // Create cache key
            var cacheKey = (values.cityId || values.cityName) + '_' + values.date + '_' + values.time;

            // Skip if same as last validation
            if (this._lastValidation === cacheKey) {
                return;
            }

            this._lastValidation = cacheKey;


            $.ajax({
                url: this.config.endpoint,
                method: 'POST',
                data: values,
                dataType: 'json',
                timeout: 5000
            })
            .done(function(response) {
                self._handleResponse(response, values);
            })
            .fail(function(xhr, status, error) {
                // On error, hide any existing warning (fail open)
                self._hideWarning();
            });
        },

        /**
         * Handle validation response
         */
        _handleResponse: function(response, values) {
            if (!response.valid) {
                this._showWarning(response.message || this._generateDefaultMessage(response, values));
            } else {
                this._hideWarning();
            }
        },

        /**
         * Generate default warning message
         */
        _generateDefaultMessage: function(response, values) {
            if (response.holiday) {
                return 'Am ' + response.holiday + ' haben alle Vermieter geschlossen. Bitte wählen Sie ein anderes Datum.';
            }

            if (response.suggestedTimes) {
                return 'Zur gewählten Uhrzeit (' + values.time + ' Uhr) sind keine Anmietungen möglich. ' +
                       'Die Vermieter haben an diesem Tag z.B. von ' +
                       response.suggestedTimes.earliest + ' bis ' + response.suggestedTimes.latest + ' Uhr geöffnet.';
            }

            return 'Für den ausgewählten Zeitpunkt sind keine Anmietungen möglich. Bitte wählen Sie einen anderen Termin.';
        },

        /**
         * Show warning message in the active tab's container
         */
        _showWarning: function(message) {
            var containerId = this._getWarningContainerId();
            var $container = $('#' + containerId);

            if ($container.length === 0) {
                this._ensureWarningContainer();
                $container = $('#' + containerId);
            }

            // Hide other tab containers first
            this._hideAllWarnings();

            // Update container class to use alert-form-hint styling
            $container.removeClass('alert alert-warning').addClass('alert-form-hint');

            // Security Fix: textContent für Message-Text (XSS Prevention)
            // Build prettier HTML structure with hint-title and hint-item classes
            $container.empty();

            // Create title div
            var titleDiv = document.createElement('div');
            titleDiv.className = 'hint-title';
            var icon = document.createElement('i');
            icon.className = 'fa fa-info-circle';
            titleDiv.appendChild(icon);
            var titleText = document.createElement('span');
            titleText.textContent = 'Hinweis';
            titleDiv.appendChild(titleText);
            $container.append(titleDiv);

            // Create message item div
            var itemDiv = document.createElement('div');
            itemDiv.className = 'hint-item';
            var itemIcon = document.createElement('i');
            itemIcon.className = 'fa fa-circle';
            itemDiv.appendChild(itemIcon);
            var messageSpan = document.createElement('span');
            messageSpan.textContent = message;
            itemDiv.appendChild(messageSpan);
            $container.append(itemDiv);

            $container.slideDown(200);
            this.warningActive = true;

            // Disable submit buttons while warning is active
            this._setSubmitButtonsDisabled(true);
        },

        /**
         * Hide all warning containers
         */
        _hideAllWarnings: function() {
            var self = this;
            $.each(this.config.warningContainers, function(key, containerId) {
                var $container = $('#' + containerId);
                if ($container.is(':visible')) {
                    $container.slideUp(200);
                }
            });
        },

        /**
         * Hide warning message
         */
        _hideWarning: function() {
            this.warningActive = false;
            this._hideAllWarnings();

            // Re-enable submit buttons (form validation will re-check)
            this._setSubmitButtonsDisabled(false);
        },

        /**
         * Disable/enable submit buttons based on opening hours warning
         */
        _setSubmitButtonsDisabled: function(disabled) {
            var $searchBtn = $('#searchBtn');
            var $nutzBtn = $('#nutz-search-desktop');
            var $modalBtn = $('#s-refresh');

            if (disabled) {
                var title = 'Bitte ein anderes Datum wählen – alle Vermieter geschlossen';
                $searchBtn.prop('disabled', true).attr('title', title);
                $nutzBtn.prop('disabled', true).attr('title', title);
                $modalBtn.prop('disabled', true).attr('title', title);
            } else {
                $modalBtn.prop('disabled', false).removeAttr('title');
                // Trigger re-validation in scripts.js to restore correct state
                if (typeof window.validateSearchFormDesktop === 'function') {
                    window.validateSearchFormDesktop();
                }
                if (typeof window.validateNutzfahrzeugeFormDesktop === 'function') {
                    window.validateNutzfahrzeugeFormDesktop();
                }
            }
        },

        /**
         * Manual validation trigger (can be called from outside)
         */
        validate: function() {
            this._scheduleValidation();
        }
    };

    // Initialize on document ready
    $(document).ready(function() {
        OpeningHoursValidation.init();
    });

})(jQuery);
